/**
 * ObjectInspectOverlay
 *
 * Zoomed object view with Signaler / Rien a signaler choices.
 */

import styles from './object-inspect-overlay.module.css';

interface ObjectInspectOverlayProps {
  imageSrc: string;
  alt: string;
  onReport: () => void;
  onDismiss: () => void;
}

export function ObjectInspectOverlay({
  imageSrc,
  alt,
  onReport,
  onDismiss,
}: ObjectInspectOverlayProps): JSX.Element {
  return (
    <div className={styles.overlay} role="dialog" aria-modal="true" aria-label="Examiner l'objet">
      <div className={styles.backdrop} />
      <div className={styles.content}>
        <div className={styles.imageFrame}>
          <img src={imageSrc} alt={alt} className={styles.image} />
        </div>
        <div className={styles.choices}>
          <button type="button" className={styles.reportButton} onClick={onReport}>
            ⚠ Signaler
          </button>
          <button type="button" className={styles.dismissButton} onClick={onDismiss}>
            ○ Rien à signaler
          </button>
        </div>
      </div>
    </div>
  );
}
